export default "__VITE_ASSET__CJFhC16Q__"